import HomeSoftware from '../pages/HomeSoftware.vue'
import DiagnosticoDigital from '../pages/DiagnosticoDigital.vue'
import NotFound from '../pages/elements/404.vue'

const sectionRoutes = [
  {
    path: '/',
    name: 'HomeSoftware',
    component: HomeSoftware,
    meta: {
      pageTitle: 'Leonix | Soluciones Digitales y Desarrollo de Software',
    },
  },
  {
    path: '/quienes-somos',
    name: 'About',
    component: HomeSoftware,
    meta: {
      sectionHash: '#about',
      pageTitle: 'Leonix | ¿Quiénes somos?',
    },
  },
  {
    path: '/servicios',
    name: 'Services',
    component: HomeSoftware,
    meta: {
      sectionHash: '#service',
      pageTitle: 'Leonix | Servicios de desarrollo y branding',
    },
  },
  {
    path: '/metodologia',
    name: 'Methodology',
    component: HomeSoftware,
    meta: {
      sectionHash: '#metodologia',
      pageTitle: 'Leonix | Metodología de trabajo',
    },
  },
  {
    path: '/contacto',
    name: 'Contact',
    component: HomeSoftware,
    meta: {
      sectionHash: '#contact',
      pageTitle: 'Leonix | Contacto y asesoría',
    },
  },
  {
    path: '/diagnostico',
    name: 'Diagnostico',
    component: DiagnosticoDigital,
    meta: {
      pageTitle: 'Leonix | Diagnóstico Digital Express',
    },
  },
]

export const routes = [
  ...sectionRoutes,
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
]

const HEADER_OFFSET = 80

export const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  }

  const hash = to.hash || (to.meta && to.meta.sectionHash)

  if (hash) {
    return {
      selector: hash,
      offset: { x: 0, y: HEADER_OFFSET },
    }
  }

  return { x: 0, y: 0 }
}
